import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { stoageGetter } from "../../helpers";

const logindata = stoageGetter("user");
let id = "";
if (logindata) {
  id = logindata.id;
}

const initialState = {
  formData:{
//   FullName: "",
//   productName: "",
//   MobileNo: "",
//   proposalStatus: "",
//   leadStatus: "",
//   userId: id,
//   lead_Owner_Id: "", //get from store
//   lead_Creator_Id: "", //get from store
//   leadId: "",
//   productId: "",
//   riders: [],
//   funds: [],
//   inputPartialWithdrawal: [],
//   formInputs: [
//     { key: "@DATEOF_COMMENCEMENT", value: "" },
//     { key: "@LI=PI", value: false },
//     { key: "@LI_NAME", value: "" },
//     { key: "@LI_DOB", value: "" },
//     { key: "@LI_ENTRY_AGE", value: "" },
//     { key: "@PROPOSER_NAME", value: "" },
//     { key: "@PROPOSER_DOB", value: "" },
//     { key: "@PROPOSER_AGE", value: "" },
//     { key: "@LI_GENDER", value: "" },
//     { key: "@PR_PT", value: "" },
//     { key: "@PR_PPT", value: "" },
//     { key: "@LI_Single/Limited", value: "" },
//     { key: "@INPUT_MODE", value: "" },
//     { key: "@PR_ANNPREM", value: 0 },
//     { key: "@LI_InstallmentPremium", value: "" },
//     { key: "@LI_AGEDEATHSUMASSURED", value: 0 },
//     { key: "@PR_MATURITYSUMASSURED", value: 0 },
//     { key: "@EMR_RATE", value: "" },
//     { key: "@RPM", value: "" },
//     { key: "@PR_ID", value: "" },
//   ],
  }
};

//bi fetched
const fetchDelaration = (state,action)=>{
  //console.log("State-->",state,"Action",action)
  const payload = action.formData;
  //console.log("red Payload" , payload);
    return updateObject(state, {
        formData: payload,
    });
}

//bi update start reducer

const editDeclarationStarted = (state) => {
  return updateObject(state, {
    editBILoading: true,
  });
};

//bi update success

// const editDeclarationSuccess = (state,action)=>{
//     const payload = { ...state.formData, ...action.formData };
//     return updateObject(state,{
//         editBiLoading: false,
//         formData: payload,
//     })
// }

const editDeclarationFail = (state, action) => {
  return updateObject(state, {
    editBIError: action.error,
    biDataloading: false,
    errorMessage: action.error,
  });
};

const reducer = (state = initialState, action) => {
 


  switch (action.type) {
    // lead
    case actionTypes.FETCH_DECLARATION:
      //console.log("~~state DEClartion" ,state);
      //console.log("~~action DEClartion" ,action);
        return fetchDelaration(state,action);
    case actionTypes.FETCH_DECLARATION_START:
      //console.log("~~state DEClartion" ,state);
      //console.log("~~action DEClartion" ,action);
      return editDeclarationStarted(state, action);
      
      // case actionTypes.FETCH_DECLARATION_SUCESS:
      //   return editDeclarationSuccess(state, action);
    case actionTypes.FETCH_DECLARATION_FAIL:
        return editDeclarationFail(state,action)
    default:
      return state;
  }
};

export default reducer;
